// Initialise error tracking before all other components
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

import { versionString } from "_utils/config";

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import store from '_store';
import { App } from './App/App';
import * as serviceWorker from './serviceWorker';

import './index.sass';

Bugsnag.start({
  apiKey: 'a624c9b320370b98bdc1aa57ae0b44f4',
  plugins: [new BugsnagPluginReact()],
  appVersion: versionString
});

const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React);

ReactDOM.render(
  <ErrorBoundary>
    <Provider store= { store }>
      <App />
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root')
);
serviceWorker.unregister();
